<div class="modal-dialog modal-md">
    <div class="modal-content">
        <div class="modal-body">
            <div class="modal-box">
                <div class="custom-header" *ngIf="!payloadData.customPay">
                    <div class="title">Amount Due: {{amount | currency}}</div>
                </div>
                <div class="button-row">
                    <div class="btn" routerLink="/customer/payment"
                    	[ngClass]="[ tab === 1 ? 'btn btn-info btn-margin-right' : 'btn btn-success btn-margin-right']" (click)="onTabClick(1)">Payment
                    </div>
                    <ng-container *ngIf="!defaultSettings?.settings.hideWallet">
                    <div class="btn" routerLink="/customer/wallet"
                        [ngClass]="[ tab === 2 ? 'btn btn-info btn-margin-right' : 'btn btn-success btn-margin-right']" (click)="onTabClick(2)">Wallet
                    </div>
                    </ng-container>
                    <ng-container *ngIf="defaultSettings?.admin || !defaultSettings?.settings.autopayAdminOnly">
                    <div class="btn" routerLink="/customer/recurring"
                        [ngClass]="[ tab === 3 ? 'btn btn-info' : 'btn btn-success']" (click)="onTabClick(3)">Recurring
                    </div>
                </ng-container>
                </div>
                <div class="green-box wallet">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>